import type { PartSvgProps } from './types'

export default function TriggerGroupSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 100,
  height = 120
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 100 120" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Hammer outline */}
      <path d="M 30 14 L 70 14 L 70 36 L 56 44 L 44 44 L 30 36 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Hammer pivot hole */}
      <circle cx="50" cy="40" r="5" fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Trigger blade */}
      <path d="M 40 44 Q 38 70 34 90 Q 36 96 40 96 Q 44 90 48 70 L 44 44 Z"
            fill={fill} stroke={accent} strokeWidth="1.5" />
      {/* Disconnector */}
      <path d="M 52 44 L 64 56 L 60 72 L 52 68 Z"
            fill={fill} stroke={stroke} strokeWidth="1.2" />
      {/* Trigger pin hole */}
      <circle cx="44" cy="60" r="4" fill="none" stroke={stroke} strokeWidth="1" />
      {/* Trigger guard arc */}
      <path d="M 30 90 Q 50 110 70 90" fill="none" stroke={stroke} strokeWidth="1.2" />
    </svg>
  )
}
